import { Ticket } from "../model/ticketEasy/Ticket";

export class TicketStartCommand {
    message: Ticket;
    
    constructor(message: Ticket) {
        this.message = message;
    }
}